<template lang="html">
 <usuario-fornecedor-aprovador-autorizado-form
   v-if="isAprovadorAutorizado"
   :somente-leitura="somenteLeitura"
   :is-conversao="isConversao">
 </usuario-fornecedor-aprovador-autorizado-form>
 <usuario-fornecedor-representante-legal-form
   v-else-if="isRepresentanteLegal"
   :somente-leitura="somenteLeitura"
   :is-conversao="isConversao">
 </usuario-fornecedor-representante-legal-form>
</template>

<script>

import UsuarioFornecedorAprovadorAutorizadoForm from '@/spa/usuario/UsuarioFornecedorAprovadorAutorizadoForm';
import UsuarioFornecedorRepresentanteLegalForm from '@/spa/usuario/UsuarioFornecedorRepresentanteLegalForm';

export default {
  name: 'UsuarioFornecedorFormNovo',
  props: {
    somenteLeitura: Boolean,
    default: false,
  },
  components: {
    UsuarioFornecedorAprovadorAutorizadoForm,
    UsuarioFornecedorRepresentanteLegalForm,
  },
  computed: {
    isAprovadorAutorizado() {
      return this.tipoFornecedor === 'APROVADOR_AUTORIZADO';
    },
    isRepresentanteLegal() {
      return this.tipoFornecedor === 'REPRESENTANTE_LEGAL';
    },
  },
  watch: {
  },
  data() {
    return {
      tipoFornecedor: null,
      isConversao: false,
    };
  },
  methods: {
  },
  beforeMount() {
  },
  mounted() {
    this.isConversao = !!this.$route.query.converterPara;
    this.tipoFornecedor = this.$route.query.converterPara || this.$route.query.tipoFornecedor || this.$route.params.tipoFornecedor;
  },
};
</script>
